module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-4@2x-baaaeb2b5811a86de8563c8d0e54bf91.png";